module.exports = __webpack_public_path__ + "static/media/audit_plus.4d3561e9.svg";